<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">FRAUD WARNINGS
              </h1>
              <img
                src="../../../public/assets/images/notepad.png"
                class="title-section-img form-title-img ops-section-img"
                alt="background image"
              >
            </article>

            <article class="input-section form-section" style="padding-right: 50px;">
              <label class="orep-label">   <strong>NOTICE TO ALL PROSPECTIVE INSUREDS: </strong></label>
              <p>
                Any person who knowingly, and with intent to defraud any insurance company or other person, files an application for
                insurance or statement of claim containing any materially false information, or, for the purpose of misleading, conceals
                information concerning any fact material thereto, may commit a fraudulent insurance act which is a crime and subjects such
                person to criminal and civil penalties in many states.              </p>

              <label class="orep-label">   <strong>NOTICE TO PROSPECTIVE INSUREDS IN: </strong></label>

              <p>
                <strong>Colorado :</strong>
                It is unlawful to knowingly provide false, incomplete or misleading facts or information to an insurance company for the
                purpose of defrauding or attempting to defraud the company. Penalties may include imprisonment, fines, denial of insurance
                and civil damages. Any insurance company or agent of an insurance company who knowingly provides false, incomplete,
                or misleading facts or information to a policyholder or claimant for the purpose of defrauding or attempting to defraud the
                policyholder or claimant with regard to a settlement or award payable for insurance proceeds shall be reported to the
                Colorado Division of Insurance within the Department of Regulatory Agencies.             </p>
              <p>
                <strong>California :</strong>
                For your protection, California law requires the following to appear on this form:  Any person who knowingly
                presents false or fraudulent information to obtain or amend insurance coverage or to make a claim for the
                payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison.             </p>
              <p>
                <strong>Alabama, Arkansas, District of Columbia, Louisiana, New Mexico, Rhode Island,West Virginia : </strong>
                Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false
                information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
              </p>
              <p>
                <strong>Florida : </strong>
                Any person who knowingly and with intent to injure, defraud or deceive any insurer files a statement of claim or an application
                containing any false, incomplete or misleading information is guilty of a felony of the third degree.
              </p>
              <p>
                <strong>Kansas : </strong>
                Any person who, knowingly and with intent to defraud, presents, causes to be presented or prepares with knowledge or
                belief that it will be presented to or by an insurer, purported insurer, broker or agent thereof, any written, electronic,
                electronic impulse, facsimile, magnetic, oral, or telephonic communication or statement as part of, or in support of, an
                application for the issuance of, or the rating of an insurance policy for personal or commercial insurance, or a claim for
                payment or other benefit pursuant to an insurance policy for commercial or personal insurance which such person knows to
                contain materially false information concerning any fact material thereto; or conceals, for the purpose of misleading,
                information concerning any fact material thereto commits a fraudulent insurance act.
              </p>
              <p>
                <strong>Kentucky : </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for
                insurance containing any materially false information or conceals, for the purpose of misleading, information concerning any
                fact material thereto commits a fraudulent insurance act, which is a crime.              </p>
              <p>
                <strong>Maine, Tennessee, Virginia,Washington : </strong>
                It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of
                defrauding the company. Penalties may include imprisonment, fines, and denial of insurance benefits.              </p>
              <p>
                <strong>Maryland : </strong>
                Any person who knowingly or willfully presents a false or fraudulent claim for payment of a loss or benefit or who knowingly
                or willfully presents false information in an application for insurance is guilty of a crime and may be subject to fines and
                confinement in prison.              </p>
              <p>
                <strong>Minnesota : </strong>
                A person who submits an application or files a claim with intent to defraud or helps commit a fraud against an insurer is
                guilty of a crime.              </p>
              <p>
                <strong>New Jersey : </strong>
                Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal
                and civil penalties.              </p>
              <p>
                <strong>New York: </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information, or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation.
              </p>
              <p>
                <strong>Ohio : </strong>
                Any person who, with intent to defraud or knowing that he/she is facilitating a fraud against an insurer, submits an application
                or files a claim containing a false or deceptive statement is guilty of insurance fraud.              </p>
              <p>
                <strong>Oregon : </strong>
                Any person who knowingly, and with intent to defraud any insurance company or other person, files an
                application for insurance or statement of claim containing any materially false information, or, for the
                purpose of misleading, conceals information concerning any fact material thereto, may commit a fraudulent
                insurance act which may be a crime and may subject such person to criminal and civil penalties.              </p>
              <p>
                <strong>Oklahoma : </strong>
                WARNING: Any person who knowingly, and with intent to injure, defraud or deceive any insurer, makes any claim for the
                proceeds of an insurance policy containing any false, incomplete or misleading information is guilty of a felony.              </p>
              <p>
                <strong>Pennsylvania : </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for
                insurance or statement of claim containing any materially false information or conceals for the purpose of misleading,
                information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such
                person to criminal and civil penalties.              </p>
              <p>
                <strong>Vermont : </strong>
                Any person who knowingly presents a false statement in an application for insurance may be guilty of a criminal offense
                and subject to penalties under state law.              </p>
              <h5 class="font-weight-bold" style="text-align: center">
                DISCLAIMER</h5>
              <h5 class="font-weight-bold">
                COMPLETION OF THIS FORM DOES NOT BIND COVERAGE. THE APPLICANT AND FIRM ACCEPTS NOTICE THAT ANY POLICY
                ISSUED WILL APPLY ON A “CLAIMS-MADE” BASIS. THE APPLICANT AND FIRM ACCEPTS NOTICE THAT THEY ARE
                REQUIRED TO PROVIDE WRITTEN NOTIFICATION TO THE COMPANY OF ANY CHANGES TO THIS APPLICATION THAT MAY
                HAPPEN BETWEEN THE SIGNATURE DATE BELOW AND ANY PROPOSED EFFECTIVE DATE. THE APPLICATION MUST BE
                SIGNED BY AN ACTIVE OWNER, PARTNER, PRINCIPAL, OFFICER, OR MEMBER OF THE APPLICANT.              </h5>

              <p>
                The undersigned is authorized by, and acting on behalf of, the Applicant and represents that all statements and particulars
                herein are true, complete and accurate to the best of their knowledge and that there has been no suppression or misstatements
                of fact and agrees that this application shall be the basis of, and becomes part of, the Applicant’s professional liability coverage.
              </p>
              <p>
                I understand that the final premium will be rounded to the nearest whole dollar. I declare that all statements and particulars herein are true, complete and accurate and that there has been no suppression or misstatements of fact and agree that this application shall be the basis of, and becomes a part of, my Professional Liability coverage.
              </p>
            </article>
            <article class="form-heading form-section review-sign">
              <div class="row">
                <p class="mt-4 mb-0 mx-5">
                  <strong>Consent to Electronic Signature: </strong>
                  I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this insurance application. (Please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a> if you do not consent to Electronic Signature.)
                </p>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Please print your name:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name"
                      name="nameForFraudWarning"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="standardApplication.nameForFraudWarning"
                    >
                    <span
                      v-show="errors.has('nameForFraudWarning')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('nameForFraudWarning') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Title:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Title"
                      name="titleForFraudWarning"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="standardApplication.titleForFraudWarning"
                    >
                    <span
                      v-show="errors.has('titleForFraudWarning')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('titleForFraudWarning') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Signature:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name to Sign"
                      name="appraiserPrincipleEsignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="standardApplication.appraiserPrincipleEsignature"
                    >
                    <span
                      v-show="errors.has('appraiserPrincipleEsignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('appraiserPrincipleEsignature') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Date:</p>
                    <input
                      type="date"
                      class="orep-text-input notice-input text-center"
                      :value="formattedCurrentDate()"
                      disabled
                    >
                  </section>
                </div>
              </div>
            </article>
            <article class="form-heading form-section review-sign" v-if="standardApplication.customer.state == 'MO' || standardApplication.customer.state == 'WY' ">
              <div class="row">
                <h5 class="mt-4 mb-0 mx-5 font-weight-bold">
                  <strong>FOR Missouri and Wyoming Applicants Only: </strong></h5>
                <h6 class="mt-4 mb-0 mx-5 font-weight-bold">
                  PLEASE ACKNOWLEDGE AND SIGN THE FOLLOWING DISCLOSURE TO YOUR APPLICATION FOR INSURANCE:             </h6>

                <h6 class="mt-4 mb-0 mx-5 font-weight-bold">
                  THE APPLICANT UNDERSTANDS AND ACKNOWLEDGES THAT THE POLICY FOR WHICH IT IS APPLYING CONTAINS A
                  DEFENSE WITHIN LIMITS PROVISION WHICH MEANS THAT CLAIMS EXPENSES WILL REDUCE THE POLICY’S LIMITS
                  OF LIABILITY AND MAY EXHAUST THEM COMPLETELY. SHOULD THAT OCCUR, THE APPLICANT SHALL BE LIABLE
                  FOR ANY FURTHER CLAIMS EXPENSES AND DAMAGES.             </h6>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Please print your name:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name to Sign"
                      name="nameForStateMoWy"
                      v-validate="standardApplication.customer.state == 'WY' || standardApplication.customer.state == 'MO' ? 'required': ''"
                      @input="validateBeforeSubmit()"
                      v-model="standardApplication.nameForStateMoWy"
                    >
                    <span
                      v-show="errors.has('nameForStateMoWy')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('nameForStateMoWy') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Title:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Title"
                      name="titleForStateMoWy"
                      v-validate="standardApplication.customer.state == 'WY' || standardApplication.customer.state == 'MO' ? 'required': ''"
                      @input="validateBeforeSubmit()"
                      v-model="standardApplication.titleForStateMoWy"
                    >
                    <span
                      v-show="errors.has('titleForStateMoWy')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('titleForStateMoWy') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Signature:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name"
                      name="signatureForStateMoWy"
                      v-validate="standardApplication.customer.state == 'WY' || standardApplication.customer.state == 'MO' ? 'required': ''"
                      @input="validateBeforeSubmit()"
                      v-model="standardApplication.signatureForStateMoWy"
                    >
                    <span
                      v-show="errors.has('signatureForStateMoWy')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('signatureForStateMoWy') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Date:</p>
                    <input
                      type="date"
                      class="orep-text-input notice-input text-center"
                      :value="formattedCurrentDate()"
                      disabled
                    >
                  </section>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'standard-application-4'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('standard-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-4')"></button>
              <button
                class="pagination-dots"
                @click="navigateToPrev('standard-application-5')">
              </button>
              <span class="pagination-dots pagination-current"></span>
              <button
                class="pagination-dots"
                @click="navigateToNext('standard-application-7')"
                :disabled="!state.pageSixIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('standard-application-8')"
                  :disabled="!state.pageSevenIsValid">
              </button>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              :disabled="!state.pageSixIsValid"
              :class="{submitDisabled: !state.pageSixIsValid}"
              @click="navigateToNext('standard-application-7')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Submitting the application...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS} from "@/utils/constants";

export default {
  name: "standard-application-6",
  data() {
    return {
      loading: false
    };
  },
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    standardApplication() {
      return this.$store.state.standardApplication.standardApplication;
    },
    state() {
      return this.$store.state.standardApplication;
    },
    errorMsg() {
      return this.$store.state.standardApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageSixIsValid = true;
          return;
        }
        this.state.pageSixIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.standardApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    formSubmit() {
      this.loading = true;
      this.state.standardApplication.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('standardApplication/createStandardApplication');
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  components: {}
};
</script>

<style scoped>
  .form-errors  {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  .notice-info > i {
    margin-top: 1rem;
  }
  .notice-form {
    margin-left: 0;
    margin-top: 2rem;
  }
  .notice-input {
    max-width: 225px;
  }
  .notice-form-date {
    margin-bottom: 20px;
  }
  p {
    font-size: 14px;
  }
</style>

